import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { navigate } from 'gatsby';
import { useIdentityContext } from 'react-netlify-identity/dist';
import { buttonSkinData, buttonBtnTypeData } from '@luigiclaudio/ga-baseline-ui/button';
import { FormSignIn } from '@luigiclaudio/ga-baseline-ui/auth';
import { useLoading } from '@luigiclaudio/ga-baseline-ui/helpers';
import useAuthFeedback from '../utils/useAuthFeedback';

var AuthSignIn = function AuthSignIn(_ref) {
  var intl = _ref.intl,
      siteName = _ref.siteName,
      navigateTo = _ref.navigateTo,
      navigateToState = _ref.navigateToState,
      buttonSkin = _ref.buttonSkin,
      buttonBtnType = _ref.buttonBtnType,
      showHeading = _ref.showHeading;

  var _useState = useState(),
      errorMessage = _useState[0],
      setErrorMessage = _useState[1];

  var _useIdentityContext = useIdentityContext(),
      loginUser = _useIdentityContext.loginUser;

  var _useLoading = useLoading(),
      isLoading = _useLoading[0],
      load = _useLoading[1];

  var _useAuthFeedback = useAuthFeedback(),
      hasForm = _useAuthFeedback.hasForm,
      handleFeedbackMessage = _useAuthFeedback.handleFeedbackMessage,
      feedbackMessage = _useAuthFeedback.feedbackMessage,
      hasFeedback = _useAuthFeedback.hasFeedback;

  var signInCallback = function signInCallback() {
    return navigate(navigateTo || '/app', {
      state: navigateToState
    });
  };

  var handleSignIn = function handleSignIn(_ref2) {
    var emailAddress = _ref2.emailAddress,
        password = _ref2.password;
    load(loginUser(emailAddress, password, true)).then(function () {
      handleFeedbackMessage({
        type: 'success',
        message: intl.formatMessage({
          id: 'auth.signIn.success.message'
        }),
        feedbackCallback: function feedbackCallback() {
          return signInCallback();
        },
        redirect: true
      });
    }).catch(function (error) {
      var errorData = error.json;
      var errorType = errorData.error,
          errorDescription = errorData.error_description;
      setErrorMessage({
        errorType: errorType,
        errorDescription: errorDescription
      });
    });
  };

  return /*#__PURE__*/React.createElement(FormSignIn, {
    siteName: siteName,
    onSubmitSignIn: function onSubmitSignIn(values) {
      return handleSignIn(values);
    },
    errorMessage: errorMessage,
    isLoading: isLoading,
    inProp: hasForm,
    inPropFeedback: hasFeedback,
    feedbackType: feedbackMessage.type,
    feedbackMessage: feedbackMessage.message,
    buttonSkin: buttonSkin,
    buttonBtnType: buttonBtnType,
    showHeading: showHeading
  });
};

AuthSignIn.defaultProps = {
  navigateTo: undefined,
  navigateToState: undefined,
  buttonSkin: 'primary',
  buttonBtnType: 'default',
  showHeading: true
};
export default injectIntl(AuthSignIn);